import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type SearchTab =
  | 'working-list'
  | 'quick-search'
  | 'custom-filter'
  | 'work-queues'
  | 'buckets'
  | 'create-new-application'
  | 'archive-search';

interface State {
  tab: SearchTab;

  actions: {
    selectTab: (tab: SearchTab) => void;
  };
}

const useState = create<State>()(
  persist(
    (set) => ({
      tab: 'working-list',
      actions: {
        selectTab: (tab) => set({ tab }),
      },
    }),
    {
      name: 'ace.searchtab',
      partialize: ({ actions: _, ...state }) => state,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export const useSelectedSearchTab = () => useState((state) => state.tab);

export const useSearchTabActions = () => useState((state) => state.actions);
